import { createI18n } from 'vue-i18n'
import { messages } from 'src/i18n'
import { currentLanguage } from 'src/utils/language'
import { setTranslator } from 'src/utils/i18n-translate'

export const i18n = createI18n({
  locale: currentLanguage.value,
  fallbackLocale: 'en',
  messages,
  legacy: false,
  globalInjection: true
})

// Lets low-level utilities translate without importing this module (see i18n-translate.ts).
setTranslator((key, named) => i18n.global.t(key, named ?? {}) as string)
